<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
        <el-col :span="20">
          <el-input placeholder="请输入字典类型或名称进行搜索..." v-model.trim="search"
                    @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索
            </el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button v-if="is_superuser"
                     size="small" type="primary" icon="el-icon-plus" @click="handleCreate">新增字典
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="dict.list" stripe fit style="width: 100%" v-loading="loading"
                    :element-loading-text="loadingText">
            <el-table-column prop="type" label="字典类型" min-width="200">
              <template slot-scope="scope">
                <span class="font-weight-bold">{{ scope.row.type }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="代码" min-width="120">
              <template slot-scope="scope">
                {{ scope.row.code }}
              </template>
            </el-table-column>
            <el-table-column prop="value" label="名称" min-width="160">
              <template slot-scope="scope">
                {{ scope.row.value }}
              </template>
            </el-table-column>
            <el-table-column prop="order" label="排序" width="80">
              <template slot-scope="scope">
                {{ scope.row.order }}
              </template>
            </el-table-column>
          </el-table>
          <pagination ref="dictPagination" :size.sync="dict.query.limit" :offset.sync="dict.query.offset" :total="dict.total"
                      @updateList="updatePageData"></pagination>
        </el-col>
      </el-row>
    </el-card>
    <dict-dialog ref="dict" @updateList="getDictList"></dict-dialog>
  </div>
</template>

<script>
  import {fetchDictAll} from '@/api/dict'
  import Pagination from '@/components/Pagination'
  import DictDialog from './dict-dialog'

  export default {
    name: "dict-list",
    components: {
      Pagination,
      DictDialog
    },
    data() {
      return {
        search: null,
        searching: false,
        loading: true,
        loadingText: '正在加载数据，请稍等...',
        is_superuser: false,
        dict: {
          query: {
            offset: 0,
            limit: 20
          },
          total: 0,
          list: null,
          allList: []
        }
      }
    },
    methods: {
      handleSearch() {
        this.searching = true
        this.dict.query.offset = 0
        if (this.$refs.dictPagination) {
          this.$refs.dictPagination.page = 1
        }
        this.filterAndPage()
        this.searching = false
      },
      filterAndPage() {
        let filtered = this.dict.allList
        if (this.search) {
          const kw = this.search.toLowerCase()
          filtered = this.dict.allList.filter(item =>
            (item.type && item.type.toLowerCase().includes(kw)) ||
            (item.value && item.value.toLowerCase().includes(kw)) ||
            (item.code && item.code.toLowerCase().includes(kw))
          )
        }
        this.dict.total = filtered.length
        const {offset, limit} = this.dict.query
        this.dict.list = filtered.slice(offset, offset + limit)
      },
      updatePageData() {
        this.filterAndPage()
      },
      getDictList() {
        this.loading = true
        fetchDictAll()
          .then(res => {
            this.dict.allList = Array.isArray(res) ? res : (res.results || [])
            this.filterAndPage()
            this.loading = false
            this.searching = false
          })
          .catch(error => {
            this.loading = false
            this.searching = false
            this.$error_message(error)
          })
      },
      handleCreate() {
        this.$refs.dict.handleCreate()
      }
    },
    created() {
      this.is_superuser = this.$store.getters.is_superuser
      this.getDictList()
    }
  }
</script>
